// ReactJs
import React from 'react'
// Node modules
import styled from 'styled-components'
// Layouts
import { Comment } from '../../../common/Text'
import Input from '../../../common/Input'

const DeclarationFormHoursContainer = styled.div`

  .declarations-notice {
    margin-top: 5px;
  }

`

export default function DeclarationFormHours({ inputLabel, inputPlaceHolder, inputFormatter, labelClassName, value,
                                                onInputChange, comment, ...props }) {

  return (
      <DeclarationFormHoursContainer>
        <Input direction="column"
                labelClassName={ labelClassName }
                label={ inputLabel }
                placeholder={ inputPlaceHolder }
                value={ value }
                formatter={ inputFormatter }
                onValueChange={ onInputChange }
        />
        <Comment className="declarations-notice">
          { comment }
        </Comment>
      </DeclarationFormHoursContainer>
   )

}